import React, { useEffect, useState } from "react";

import axios from "axios";



import { useGlobalContext } from "../../../../Context/GlobalContext";

import HistoryForm from "./HistoryForm";

import HistoryList from "./HistoryList";

import ReminderForm from "./ReminderForm";

import FailedMsg from "../../../../Extra/FailedMsg";

import SuccessMsg from "../../../../Extra/SuccessMsg";

import Loading from "../../../../Extra/Loading";



const current_status = [
  "REQUIREMENT",
  "APPROVAL",
  "APPROVED",
  "ACCOUNTS",
  "FINANCE_SANCTION",
  "FINANCE_CONCURRENCE",
  "DEMAND",
  "FUND_AVAILABILITY",
  "UDM",
  "FUND_VETTING",
  "SANCTION",
  "STORE",
  "TPI",
  "TS_RR",
  "PAYMENT",
  "COMPLETED",
  "REJECTED",
  "NOT_COMPLETED",
  "OTHER",
];



const urlPrefix = process.env.REACT_APP_URL_PREFIX;



const ProcurementHistory = ({ row, onClose }) => {

  const { userData } = useGlobalContext();



  const [loading, setLoading] = useState(false);

  const [caseData, setCaseData] = useState(null);

  const [historyData, setHistoryData] = useState([]);

  const [remindersData, setRemindersData] = useState([]);

  const [documentsData, setDocumentsData] = useState([]);

  const [showReminder, setShowReminder] = useState(false);

  const [selectedHistory, setSelectedHistory] = useState(null);



  const [editingHistory, setEditingHistory] = useState(null);



  // ============================================================

  // ADD HISTORY FORM

  // ============================================================



  const [show, setShow] = useState(false);

  const [result, setResult] = useState({

    success: "",

    error: "",

  });



  // ============================================================

  // API RESPONSE MESSAGE

  // ============================================================



  const [showSuccess, setShowSuccess] = useState(false);

  const [showError, setShowError] = useState(false);



  // ============================================================

  // CASE ID

  // ============================================================



  const caseId = row?.case_id;



  // ============================================================

  // FETCH HISTORY

  // ============================================================



  const fetchHistory = async () => {

    if (!caseId) {

      return;

    }



    try {

      setLoading(true);



      const response = await axios.get(

        `${urlPrefix}store/procurements/${caseId}`,

      );



      const data = response?.data?.data?.[0];

      setDocumentsData(data?.documents || []);

      setHistoryData(data?.history || []);

      setRemindersData(data?.reminders || []);

    } catch (error) {

      console.error("Failed to fetch procurement history:", error);



      const message =

        error?.response?.data?.message ||

        "Failed to fetch procurement history.";



      setResult({

        success: "",

        error: message,

      });



      setShowError(true);

    } finally {

      setLoading(false);

    }

  };



  useEffect(() => {

    fetchHistory();

  }, [caseId]);



  // ============================================================

  // EXTRACT HISTORY ID

  // ============================================================



  const extractHistoryId = (response) => {

    const data = response?.data?.data[0];



    return (

      data?.history_id ||

      data?.data?.history_id ||

      data?.data?.data?.history_id ||

      data?.data?.history?.history_id ||

      data?.history?.history_id ||

      null

    );

  };



  // ============================================================

  // UPLOAD DOCUMENT

  // ============================================================



  const uploadHistoryDocument = async ({ file, historyId, remarks }) => {

    if (!file || !historyId) {

      return null;

    }



    const formData = new FormData();



    formData.append("document", file);

    formData.append("document_type", "QUERY_REMINDER");

    formData.append("remarks", remarks || "");

    formData.append("uploaded_by", String(userData?.id || ""));

    formData.append("history_id", String(historyId));



    const response = await axios.post(

      `${urlPrefix}store/procurements/${caseId}/documents`,

      formData,

    );



    return response;

  };



  // ============================================================

  // SAVE NEW HISTORY 

  // ============================================================



  const saveHistory = async (form) => {

    setLoading(true);

    try {

      setShow(false);

      setResult({

        success: "",

        error: "",

      });



      setShowSuccess(false);

      setShowError(false);



      // --------------------------------------------------------

      // STEP 1: CREATE HISTORY

      // --------------------------------------------------------



      const historyPayload = {

        status_stage: form.status_stage,

        action_date: form.action_date,

        remarks: form.remarks || "",

        created_by: userData?.id || "",

      };



      const historyResponse = await axios.post(

        `${urlPrefix}store/procurements/${caseId}/history`,

        historyPayload,

      );



      // --------------------------------------------------------

      // STEP 2: GET GENERATED HISTORY ID

      // --------------------------------------------------------



      const historyId = extractHistoryId(historyResponse);



      if (!historyId) {

        throw new Error(

          "History was created, but history_id was not returned by the server.",

        );

      }



      // --------------------------------------------------------

      // STEP 3: UPLOAD DOCUMENT IF SELECTED

      // --------------------------------------------------------



      if (form.document) {

        await uploadHistoryDocument({

          file: form.document,

          historyId,

          remarks: form.remarks,

        });

      }



      // --------------------------------------------------------

      // STEP 4: SUCCESS MESSAGE

      // --------------------------------------------------------



      const successMessage = form.document

        ? "History and document saved successfully."

        : "History saved successfully.";



      setResult({

        success: successMessage,

        error: "",

      });



      setShowSuccess(true);



      // --------------------------------------------------------

      // STEP 5: REFRESH

      // --------------------------------------------------------



      await fetchHistory();

    } catch (error) {

      console.error("Save history/document error:", error);



      const message =

        error?.response?.data?.message ||

        error?.message ||

        "Failed to save history.";



      setResult({

        success: "",

        error: message,

      });



      setShowError(true);

    } finally {

      setLoading(false);

    }

  };



  // ============================================================

  // UPDATE HISTORY

  // ============================================================



  const updateHistory = async (form) => {

    if (!editingHistory?.history_id) {

      return;

    }



    try {

      setLoading(true);



      setResult({

        success: "",

        error: "",

      });



      setShowSuccess(false);

      setShowError(false);



      const historyId = editingHistory.history_id;



      const historyPayload = {

        // history_id: historyId,

        status_stage: form.status_stage,

        action_date: form.action_date,

        remarks: form.remarks || "",

        updated_by: editingHistory.created_by || userData?.id || "",

      };



      // --------------------------------------------------------

      // STEP 1: UPDATE HISTORY

      // --------------------------------------------------------



      await axios.put(

        `${urlPrefix}store/procurements/history/${historyId}`,

        historyPayload,

      );



      // --------------------------------------------------------

      // STEP 2: OPTIONAL DOCUMENT

      // --------------------------------------------------------



      if (form.document) {

        await uploadHistoryDocument({

          file: form.document,

          historyId,

          remarks: form.remarks,

        });

      }



      // --------------------------------------------------------

      // STEP 3: SUCCESS

      // --------------------------------------------------------



      const successMessage = form.document

        ? "History and document updated successfully."

        : "History updated successfully.";



      setResult({

        success: successMessage,

        error: "",

      });



      setShowSuccess(true);



      // --------------------------------------------------------

      // STEP 4: RESET

      // --------------------------------------------------------



      setEditingHistory(null);



      await fetchHistory();

    } catch (error) {

      console.error("Update history/document error:", error);



      const message = error?.message || "Failed to update history.";



      setResult({

        success: "",

        error: message,

      });



      setShowError(true);

    } finally {

      setLoading(false);

    }

  };



  // ============================================================

  // START EDIT

  // ============================================================



  const startEdit = (history) => {

    setEditingHistory(history);

    setShow(false);

  };



  // ============================================================

  // CANCEL EDIT

  // ============================================================



  const cancelEdit = () => {

    setEditingHistory(null);

  };



  // ============================================================

  // OPEN REMINDER

  // ============================================================



  const openReminder = (history, reminder = null) => {

    setSelectedHistory({

      ...history,

      selectedReminder: reminder,

    });



    setShowReminder(true);

  };



  // ============================================================

  // CLOSE REMINDER

  // ============================================================



  const closeReminder = () => {

    setShowReminder(false);

    setSelectedHistory(null);

  };

  const handleReminderSuccess = async (message) => {

    setResult({

      success: message,

      error: "",

    });



    setShowSuccess(true);



    await fetchHistory();



    setShowReminder(false);

    setSelectedHistory(null);

  };



  // ============================================================

  // CLOSE

  // ============================================================



  const handleClose = () => {

    if (onClose) {

      onClose();

    }

  };



  // ============================================================

  // SUCCESS MESSAGE CLOSE

  // ============================================================



  const closeSuccess = () => {

    setShowSuccess(false);



    setResult((prev) => ({

      ...prev,

      success: "",

    }));

  };



  // ============================================================

  // ERROR MESSAGE CLOSE

  // ============================================================



  const closeError = () => {

    setShowError(false);



    setResult((prev) => ({

      ...prev,

      error: "",

    }));

  };



  // ============================================================

  // RENDER

  // ============================================================



  return (

    <div

      className="modal fade show d-block"

      tabIndex="-1"

      style={{

        backgroundColor: "rgba(0,0,0,0.5)",

      }}

    >

      <div className="modal-dialog modal-xl modal-dialog-scrollable">

        <div className="modal-content">

          {/* ==================================================

              HEADER

          \================================================== */}



          <div className="modal-header">

            <div>

              <h5 className="modal-title fw-bold">Procurement History</h5>



              <div className="small text-muted">

                Case ID: <strong>{caseId || "-"}</strong>

              </div>

            </div>



            <button

              type="button"

              className="btn-close"

              onClick={handleClose}

              disabled={loading}

            />

          </div>



          <div className="modal-body">

            {result.success && (

              <div className="mb-3">

                <SuccessMsg

                  head="Success"

                  message={result.success}

                  show={showSuccess}

                  setShow={closeSuccess}

                />

              </div>

            )}



            {result.error && (

              <div className="mb-3">

                <FailedMsg

                  head="Failed"

                  message={result.error}

                  show={showError}

                  setShow={closeError}

                />

              </div>

            )}



            {/* ==================================================

                EDIT FORM

            \================================================== */}



            {editingHistory ? (

              <HistoryForm

                mode="edit"

                history={editingHistory}

                currentStatus={current_status}

                onSubmit={updateHistory}

                onCancel={cancelEdit}

                loading={loading}

              />

            ) : (

              <>

                {/* ==================================================

                    ADD FORM BUTTON

                \================================================== */}



                <button

                  type="button"

                  className="btn btn-primary mb-3"

                  onClick={() => setShow((prev) => !prev)}

                  disabled={loading}

                >

                  {show ? "✕ Cancel" : "+ Add History"}

                </button>



                {/* ==================================================

                    ADD FORM

                \================================================== */}



                {show && (

                  <HistoryForm

                    mode="add"

                    defaultStatus=""

                    currentStatus={current_status}

                    onSubmit={saveHistory}

                    onCancel={() => setShow(false)}

                    loading={loading}

                  />

                )}

              </>

            )}



            {/* ==================================================

                HISTORY LIST

            \================================================== */}



            {loading && caseData && historyData.length === 0 ? (

              <Loading />

            ) : (

              <HistoryList

                fetchHistory={fetchHistory}

                caseData={row}

                historyData={historyData}

                documents={documentsData}

                remindersData={remindersData}

                onEdit={startEdit}

                onReminder={openReminder}

              />

            )}

          </div>



          {/* ==================================================

              FOOTER

          \================================================== */}



          <div className="modal-footer">

            <button

              type="button"

              className="btn btn-secondary"

              onClick={handleClose}

              disabled={loading}

            >

              Close

            </button>

          </div>

        </div>

      </div>



      {/* ======================================================

          REMINDER MODAL

      \====================================================== */}



      {showReminder && selectedHistory && (

        <ReminderForm

          row={row}

          history={selectedHistory}

          reminder={selectedHistory.selectedReminder}

          onClose={closeReminder}

          onSuccess={handleReminderSuccess}

        />

      )}

    </div>

  );

};



export default ProcurementHistory;
